import { createFileRoute } from "@tanstack/react-router";
import { PlatformSchedulerPage } from "@/components/platform-scheduler-page";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/channels/youtube";

export const Route = createFileRoute(path)({
	component: YouTubeScheduler,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "AgentReacher | Connect your AI agent to YouTube",
			description:
				"Schedule YouTube videos and Shorts with an AI agent that writes titles, descriptions, and tags. Cancel anytime.",
		}),
});

function YouTubeScheduler() {
	return (
		<PlatformSchedulerPage
			platform="youtube"
			platformLabel="YouTube"
			hero={{
				title: "Connect your AI agent to YouTube",
				description:
					"Upload videos and Shorts. AgentReacher writes the title, description, and tags, then schedules the publish.",
			}}
		/>
	);
}
